import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Button, Input, Label } from "reactstrap";

const EmbedModal = ({ isOpen, toggle, owner }) => {
  const [iframeWidth, setIframeWidth] = useState("100%");
  const [iframeHeight, setIframeHeight] = useState("600px");

  const encodedOwner = btoa(owner?.attributes?.ownerEmail || "");
  const embedCode = `<iframe src="${process.env.REACT_APP_API_BASE_URL}/stats/widget.html?key=${encodedOwner}" width="${iframeWidth}" height="${iframeHeight}" style="border:none;"></iframe>`;

  const handleCopy = () => {
    navigator.clipboard.writeText(embedCode).then(() => {
      alert("Copied!");
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>Add Calendar to Your Website</ModalHeader>
      <ModalBody>
        {/* Iframe Width */}
        <div className="card" style={{ marginBottom: "10px" }}>
          <p className="p-2 m-0"><small >The below code can be added to a page on your website to display this schedule on your website. Just click the Copy Code button and paste in an email to your web developer!</small></p>
        </div>

        <div style={{ marginBottom: "10px" }}>
          <Label for="iframeWidth">Iframe Width</Label>
          <Input
            id="iframeWidth"
            type="text"
            value={iframeWidth}
            onChange={(e) => setIframeWidth(e.target.value)}
            placeholder="e.g., 100% or 800px"
          />
        </div>

        {/* Iframe Height */}
        <div style={{ marginBottom: "10px" }}>
          <Label for="iframeHeight">Iframe Height</Label>
          <Input
            id="iframeHeight"
            type="text"
            value={iframeHeight}
            onChange={(e) => setIframeHeight(e.target.value)}
            placeholder="e.g., 600px"
          />
        </div>

        {/* Embed Code */}
        <div style={{ marginBottom: "10px" }}>
          <Label>Embed Code</Label>
          <textarea
            readOnly
            value={embedCode}
            style={{
              width: "100%",
              height: "100px",
              fontFamily: "monospace",
              fontSize: "14px",
            }}
          />
        </div>

        {/* Copy Button */}
        <Button color="secondary" onClick={handleCopy} block>
          COPY CODE
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default EmbedModal;
